import { render, staticRenderFns } from "./newChapter.vue?vue&type=template&id=024ee01a&scoped=true&"
import script from "./newChapter.vue?vue&type=script&lang=js&"
export * from "./newChapter.vue?vue&type=script&lang=js&"
import style0 from "./newChapter.vue?vue&type=style&index=0&id=024ee01a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024ee01a",
  null
  
)

export default component.exports